import BaseRailsRequestController from "./base_rails_request_controller";

// Connects to data-controller="preferences-checkbox"
export default class extends BaseRailsRequestController {
  static outlets = ["shipment-item"];
  static values = {
    url: String,
    errorMessage: String,
  };

  async updatePreferences(event) {
    if (!this.hasUrlValue) return;

    const checkbox = event.target;
    const key = checkbox.name;
    const value = checkbox.checked;
    const formData = new FormData();

    formData.append("name", key);
    formData.append("value", value);

    checkbox.disabled = true;

    const options = {
      responseKind: "turbo-stream",
      body: formData,
    };

    // Format key e.g. "stackable_modal" to "stackableModalValue"
    const formattedKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()) + "Value";

    this.fetchWithProgress("patch", this.urlValue, options)
      .then((response) => {
        checkbox.disabled = false;

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        this.shipmentItemOutlets.forEach((outlet) => {
          outlet[formattedKey] = true;
        });
      })
      .catch((error) => {
        console.error("Error loading preferences:", error);
        window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.errorMessageValue } }));
      });
  }
}
